import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

const blogTopics = [
  {
    id: "preparation-log",
    icon: "ri-plane-line",
    label: "渡米までの記録",
    text: "出願、ビザ、持ち物、渡航までの準備でやったことを時系列で振り返ります。",
  },
  {
    id: "campus-life",
    icon: "ri-building-2-line",
    label: "現地での学生生活",
    text: "授業の受け方、課題の量、寮や住まい、食事など、日々の生活の記録です。",
  },
  {
    id: "transfer-prep",
    icon: "ri-line-chart-line",
    label: "編入に向けた準備",
    text: "履修計画やGPA、志望校の調べ方など、編入を目指して進めていることを書いていきます。",
  },
];

export default function Blog() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <section className="w-full border-b border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-content px-5 py-14 md:px-6 md:py-20">
            <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-accent-700">
              <span className="h-[1px] w-6 bg-accent-500" />
              Blog
            </p>
            <h1 className="mt-4 font-heading text-[28px] font-bold leading-[1.5] tracking-tight text-foreground-950 md:text-[38px]">
              留学ブログ
            </h1>
            <p className="mt-5 max-w-2xl text-[13.5px] leading-[2] text-foreground-700 md:text-[14.5px]">
              日々の記録や、記事にするほど整理できていない実体験は、noteで更新しています。制度の基本をまとめた記事は、サイト内の「無料で学ぶ」に掲載しています。
            </p>
          </div>
        </section>

        <section className="w-full bg-background-50">
          <div className="mx-auto w-full max-w-content px-5 py-14 md:px-6 md:py-16">
            <div className="grid gap-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)] lg:gap-10">
              <div className="rounded-[12px] border border-background-200 bg-background-100 p-7 md:p-9">
                <p className="inline-flex items-center gap-2 rounded-full bg-background-50 px-3.5 py-1 text-[11px] font-semibold text-foreground-600">
                  <i className="ri-external-link-line text-[12px]" />
                  外部サイト（note）
                </p>
                <h2 className="mt-5 font-heading text-[21px] font-bold leading-[1.6] text-foreground-950 md:text-[24px]">
                  mypace_diary
                </h2>
                <p className="mt-3 text-[13px] leading-[2] text-foreground-700">
                  留学エージェントを使わずに渡米した現役コミカレ生の記録。出願やビザの準備、現地での生活、編入に向けた準備などを、その時々の実感とともに書いています。
                </p>
                <a
                  href="https://note.com/mypace_diary"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-6 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-7 py-3.5 text-[13.5px] font-semibold text-background-50 shadow-sm transition-all hover:-translate-y-0.5 hover:bg-accent-600 hover:shadow-md"
                >
                  noteでブログを読む
                  <i className="ri-external-link-line text-[14px]" />
                </a>
                <p className="mt-3 break-all text-[11.5px] text-foreground-500">
                  https://note.com/mypace_diary
                </p>
              </div>

              <div>
                <h2 className="flex items-start gap-3 font-heading text-[19px] font-bold leading-[1.6] text-foreground-950">
                  <span className="mt-[9px] h-[3px] w-6 shrink-0 rounded-full bg-primary-500" />
                  noteで書いていること
                </h2>
                <ul className="mt-5 space-y-3">
                  {blogTopics.map((topic) => (
                    <li
                      key={topic.id}
                      className="flex items-start gap-3 rounded-[8px] border border-background-200 bg-background-50 px-4 py-3.5"
                    >
                      <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-50 text-primary-700">
                        <i className={`${topic.icon} text-[17px]`} />
                      </span>
                      <div>
                        <p className="font-heading text-[13.5px] font-bold text-foreground-950">
                          {topic.label}
                        </p>
                        <p className="mt-1 text-[12px] leading-[1.85] text-foreground-600">
                          {topic.text}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-10 flex flex-col gap-3 rounded-[10px] border border-background-200 bg-background-100 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-[12px] leading-[1.9] text-foreground-600">
                制度の基本をまとめた記事は、サイト内で無料公開しています。
              </p>
              <Link
                to="/learn"
                className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full bg-primary-700 px-5 py-2.5 text-[12.5px] font-semibold text-background-50 transition-colors hover:bg-primary-800"
              >
                無料で学ぶ
                <i className="ri-arrow-right-line text-[14px]" />
              </Link>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}